/**
 * Ajax submission and jquery validation messages/methods for forms
 */
var _submitForms = new Array();
var submitTo = function(obj, func) {
	// add form to submit form
	_submitForms.push({
		"obj" : obj, 
		"func" : func
	});
};

var formsToValidate;

$(function() {
	
	submitTo("#contact_form", function(form) {
		var f = $(form);
		$("button",f).html("Vent");
		$("button",f).get(0).disabled = 1;
		$('.error', f).remove();
		$.post(f.attr('action'), f.serialize(), function(data) {
			f.html("Tak for din henvendelse.");
		},"text")
		.fail(function(data) {
			$("button",f).get(0).disabled = 0;
			$("button",f).html("Send");
			f.prepend('<li class="error">Der skete en fejl: '+Contenda.t(data.responseText)+'</li>');
		});
	});
	
	// validation
	// Override default error message
//    jQuery.validator.messages.required = "";
	
    // custom methods
    jQuery.validator.addMethod("dkZipRange", function(value, element) {
    	return this.optional(element) || /^[1-9]\d{3}$/.test(value); 
    	//(1-9) followed by 3 times (0-9)
    }, Contenda.t("Please enter a four digit zip-code."));
    // }, Contenda.t("Indtast venligst et 4-cifret postnummer."));
    
    jQuery.validator.addMethod("zipRange", function(value, element) {
    	return this.optional(element) || /^[\d|\w|\s]{4,7}$/.test(value);
    }, Contenda.t("Please enter a valid zip-code."));
	// }, Contenda.t("Indtast venligst et gyldigt postnummer."));
    
    jQuery.validator.addMethod("phoneNr", function(value, element) {
    	return this.optional(element) || /^\+?(\d[\d\-\+\(\) ]{5,}\d$)/.test(value); 
    	//possible +, followed by (at least 5) digits, -, +, (, or ) 
    }, Contenda.t("Please enter a valid phone number."));
	// }, Contenda.t("Indtast venligst et gyldigt telefonnummer."));

    jQuery.validator.addMethod("dropkick", function(value, element, param) {
    	// Validation methods
    	var validationMethods = jQuery.validator.methods;
    	$(param.element).removeClass("error");
    	
    	// iterate through param methods, and apply them, 
    	// for validation like it was an ordinary method
    	for ( var m in param.methods) {
    		
			// if method is enabled
			if (param.methods[m] && !validationMethods[m].call(this, value, element, param.methods[m])) {
				// check if it validates
				// if not - return false
				$(param.element).addClass("error");
				return false;
			}
		}
    	
    	return true;
    //}, Contenda.t("Please select a valid choice in the dropdown menu"));
	}, Contenda.t("Please select a valid choice in the dropdown menu"));
    
    // number tests
    jQuery.validator.addMethod("greaterThan", function(value, element, param) {
    	var test = $('[name="' + param + '"]').val();
	    return this.optional(element) || parseInt(value) > parseInt(test);
	}, jQuery.validator.format(Contenda.t("Enter a value greater than {0}.")));
	// }, jQuery.validator.format(Contenda.t("Angiv en værdi der er større end {0}.")));
    
    jQuery.validator.addMethod("lessThan", function(value, element, param) {
    	var test = $('[name="' + param + '"]').val();
	    return this.optional(element) || parseInt(value) < parseInt(test);
	}, jQuery.validator.format(Contenda.t("Enter a value less than {0}.")));
	// }, jQuery.validator.format(Contenda.t("Angiv en værdi der er mindre end {0}.")));
    
    jQuery.validator.addMethod("greaterThanEq", function(value, element, param) {
    	var test = $('[name="' + param + '"]').val();
	    return this.optional(element) || parseInt(value) >= parseInt(test);
	}, jQuery.validator.format(Contenda.t("Enter a value that is at least {0}.")));
	// }, jQuery.validator.format(Contenda.t("Angiv en værdi der er mindst {0}.")));
    
    jQuery.validator.addMethod("lessThanEq", function(value, element, param) {
    	var test = $('[name="' + param + '"]').val();
	    return this.optional(element) || parseInt(value) <= parseInt(test);
	}, jQuery.validator.format(Contenda.t("Enter a value that is at most {0}.")));
	// }, jQuery.validator.format(Contenda.t("Angiv en værdi der er højst {0}.")));

    // Lexically tests
    jQuery.validator.addMethod("greaterThanLex", function(value, element, param) {
    	var test = $('[name="' + param + '"]').val();
    	return this.optional(element) || value > test;
    }, jQuery.validator.format(Contenda.t("Enter a value greater than {0}.")));
	// }, jQuery.validator.format(Contenda.t("Angiv en værdi der er større end {0}.")));
    
    jQuery.validator.addMethod("lessThanLex", function(value, element, param) {
    	var test = $('[name="' + param + '"]').val();
    	return this.optional(element) || value < test;
    }, jQuery.validator.format(Contenda.t("Enter a value less than {0}.")));
    // }, jQuery.validator.format(Contenda.t("Angiv en værdi der er mindre end {0}.")));
    
    jQuery.validator.addMethod("greaterThanEqLex", function(value, element, param) {
    	var test = $('[name="' + param + '"]').val();
    	return this.optional(element) || value >= test;
    }, jQuery.validator.format(Contenda.t("Enter a value that is at least {0}.")));
	// }, jQuery.validator.format(Contenda.t("Angiv en værdi der er mindst {0}.")));
    
    jQuery.validator.addMethod("lessThanEqLex", function(value, element, param) {
    	var test = $('[name="' + param + '"]').val();
    	return this.optional(element) || value <= test;
    }, jQuery.validator.format(Contenda.t("Enter a value that is at most {0}.")));
	// }, jQuery.validator.format(Contenda.t("Angiv en værdi der er højst {0}.")));
    
    window.formsToValidate = $('form').not('.noValidate');
	
    formsToValidate.each(function() {
    	var currentForm = $(this);
    	
    	var validation = {
    		// custom methods to enable the "onkeyup: false/true" property on each field
    		onkeyup: function(element) {
    			var element_id = jQuery(element).attr('name');
    		    if (this.settings.rules[element_id] && this.settings.rules[element_id].onkeyup !== false) {
    		    	jQuery.validator.defaults.onkeyup.apply(this, arguments);
    		    }
    		},
    		// set general rules
			rules: {
				// user related
				firstname : {
					required : true,
					minlength: 2
				},
				lastname : {
					required : true,
					minlength: 2
				},
				name : {
					required : true,
					minlength: 2
				},
				email : {
					required : true,
					email : true,
					onkeyup: false
				},
				address : {
					required : true,
					minlength: 5
				},
				zipcode : {
					required : true,
					zipRange : true,
					dkZipRange : true
				},
				city : {
					required : true
				},
				password : {
					required : true,
					minlength: 6
				},
				repeatpassword : {
					equalTo: "#password"
				},
				message : {
					required : true
				},
				phone : {
					required: true,
					phoneNr: true
				},
				vat : {
					required: true,
					minlength: 6
				},
				country : {
					dropkick : {
						element : "option",
						methods : {
							required : true
						}
					}
				},
				terms : {
					required : true
				}
				
			}, 
			errorPlacement: function(error, element) {
			if (element.attr("name") == "terms")
				error.insertAfter('.radiolabel[for=terms]');
			else
				error.insertBefore(element);
			},
			messages : jQuery.validator.messages,
			submitHandler : function(form) {
				for (var formular in _submitForms) {
					if ($(_submitForms[formular].obj).is(form)) {
						// console.log("yes");
						// run attached form handler
						return _submitForms[formular].func(form);
					}
				}
				console.log("no submit handler defined");
				form.submit();
			},
			errorLabelContainer: $("ul.validationerr", currentForm),
			wrapper: 'li',
			
		};

    	currentForm.validate(validation);
    });
});